import { Route, Routes } from 'react-router-dom';
import ComplaintManagementPage from '../pages/ComplaintManagementPage';
import ComplaintSettingsPage from '../pages/ComplaintSettingsPage';

function ComplaintRouter({ pageProps, onPublish, onStepChange, children }) {
  const managementPage = children ?? <ComplaintManagementPage {...pageProps} />;

  return (
    <Routes>
      <Route path="/" element={managementPage} />
      <Route
        path="/settings/:systemId"
        element={
          <ComplaintSettingsPage
            onPublish={onPublish}
            onStepChange={onStepChange}
          />
        }
      />
      <Route path="*" element={managementPage} />
    </Routes>
  );
}

export default ComplaintRouter;
